import { Viewer } from "gs-longan";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import "./axiosRequest";
// import "./registerServiceWorker";
import "gs-bim-air/plugins/element";
import "gs-bim-air/plugins/gsElement";
import forbiddenF12 from "gs-bim-air/utils/forbiddenF12";
// import { initBackend } from "absurd-sql/dist/indexeddb-main-thread";

// import "./plugins/element";
// import "./plugins/gsElement";
import { cleanAllIDB } from "gs-longan/api/indexedDB";

import "./assets/iconfont/iconfont.css";

const config = require("../package.json");
console.log(`%c${config.name}: v${config.version}`, "color: #ff8000");

Vue.config.productionTip = false;
Vue.config.devtools = true;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

if (process.env.NODE_ENV === "production") {
  forbiddenF12();
}
// let worker = new Worker(new URL("./sqlite.worker.js", import.meta.url));
// initBackend(worker);

// cleanAllIDB();
